module.exports = __webpack_public_path__ + "assets/ivc-get-notified.883a1e01.svg";